export default __webpack_public_path__ + "static/media/like.659f97ee.svg";